import { defineComponent as h, getCurrentInstance as f, provide as g, ref as p, h as w } from "vue";
import P from "./ghl-ui.es1024.js";
import { imagePreviewSharedProps as x } from "./ghl-ui.es1022.js";
import I from "./ghl-ui.es854.js";
import { createId as S } from "./ghl-ui.es939.js";
import { createInjectionKey as T } from "./ghl-ui.es896.js";
const b = T("n-image-group"), y = x, j = h({
  name: "ImageGroup",
  props: y,
  setup(t) {
    let s;
    const {
      mergedClsPrefixRef: v
    } = I(t), m = `c${S()}`, i = f(), l = (e) => {
      var r;
      s = e, (r = n.value) === null || r === void 0 || r.setPreviewSrc(e);
    };
    function d(e) {
      var r, a;
      if (!(i != null && i.proxy))
        return;
      const o = i.proxy.$el.parentElement.querySelectorAll(`[data-group-id=${m}]:not([data-error=true])`);
      if (!o.length)
        return;
      const u = Array.from(o).findIndex((c) => c.dataset.previewSrc === s);
      ~u ? l(o[(u + e + o.length) % o.length].dataset.previewSrc) : l(o[0].dataset.previewSrc), e === 1 ? (r = t.onPreviewNext) === null || r === void 0 || r.call(t) : (a = t.onPreviewPrev) === null || a === void 0 || a.call(t);
    }
    g(b, {
      mergedClsPrefixRef: v,
      setPreviewSrc: l,
      setThumbnailEl: (e) => {
        var r;
        (r = n.value) === null || r === void 0 || r.setThumbnailEl(e);
      },
      toggleShow: () => {
        var e;
        (e = n.value) === null || e === void 0 || e.toggleShow();
      },
      groupId: m
    });
    const n = p(null);
    return {
      mergedClsPrefix: v,
      previewInstRef: n,
      next: () => {
        d(1);
      },
      prev: () => {
        d(-1);
      }
    };
  },
  render() {
    return w(P, {
      theme: this.theme,
      themeOverrides: this.themeOverrides,
      clsPrefix: this.mergedClsPrefix,
      ref: "previewInstRef",
      onPrev: this.prev,
      onNext: this.next,
      showToolbar: this.showToolbar,
      showToolbarTooltip: this.showToolbarTooltip
    }, this.$slots);
  }
});
export {
  j as default,
  b as imageGroupInjectionKey,
  y as imageGroupProps
};
